export default {
  messageType: 'Carousel Feed',
  carouselSetting: 'Carousel Settings',
  title: 'Carousel Feed Settings',
  label: {
    feed: 'Carousel Feed Settings',
    title: 'Title',
    content: 'Content',
    imageLink: 'Image Link',
  },
  placeholder: {
    imageLink: 'Clicking the image will redirect to the registered link.',
  },
  alt: {
    image: 'Carousel Feed Image',
  },
  comment: {
    image: 'Recommended: 800x400 (2:1), 800x600 (4:3) / Max 5MB',
  },
  validation: {
    list: {
      max: 'Only up to 6 carousel-feed feeds can be set.',
    },
  },
};
